<div class="request-expanded-row">
  <div class="request-expanded-row__summary">
    <div class="request-expanded-row__block">
      <span class="request-expanded-row__label">Warehouse</span>
      <span class="request-expanded-row__value">{{ request.warehouse?.name || "-" }}</span>
    </div>
    <div class="request-expanded-row__block">
      <span class="request-expanded-row__label">Note</span>
      <span class="request-expanded-row__value">{{ request.note || "-" }}</span>
    </div>
  </div>

  <div class="request-expanded-row__metrics">
    <div class="request-expanded-row__metric">
      <span class="request-expanded-row__label">Items</span>
      <strong>{{ request.items.length }}</strong>
    </div>
    <div class="request-expanded-row__metric">
      <span class="request-expanded-row__label">Requested</span>
      <strong>{{ getTotalRequested() }}</strong>
    </div>
    <div class="request-expanded-row__metric">
      <span class="request-expanded-row__label">Boxed</span>
      <strong>{{ getTotalBoxed() }}</strong>
    </div>
    <div class="request-expanded-row__metric">
      <span class="request-expanded-row__label">Dispatched</span>
      <strong>{{ getTotalDispatched() }}</strong>
    </div>
    <div class="request-expanded-row__metric">
      <span class="request-expanded-row__label">Delivered</span>
      <strong>{{ getTotalDelivered() }}</strong>
    </div>
    <div class="request-expanded-row__metric">
      <span class="request-expanded-row__label">Remaining</span>
      <strong>{{ getTotalRemaining() }}</strong>
    </div>
  </div>

  <div class="request-expanded-row__items">
    <div class="request-expanded-row__items-header">
      <span>Material</span>
      <span>SKU</span>
      <span>Requested</span>
      <span>Boxed</span>
      <span>Dispatched</span>
      <span>Delivered</span>
      <span>Remaining</span>
    </div>
    @for (item of request.items; track $index) {
    <div class="request-expanded-row__item-row">
      <span>{{ item.material?.name || "-" }}</span>
      <span>{{ item.material?.sku || "-" }}</span>
      <span>{{ item.qty }}</span>
      <span>{{ item.boxedQty ?? 0 }}</span>
      <span>{{ item.dispatchedQty ?? 0 }}</span>
      <span>{{ item.deliveredQty ?? 0 }}</span>
      <span>{{ getRemainingQty(item) }}</span>
    </div>
    }
  </div>
</div>
